export const MANAGE_EXTRA_ACTIVITY_TEXT = {
	addTitle: 'Add extra activity',
	manageTitle: 'Manage extra activity',
	description:
		'Please select the type and duration, and specify the station or segment for extra activity',
	manageDescription: 'Please update the duration for extra activity',
	locationLabel: 'Location',
	locationPlaceholder: 'Select a location',
	extraActivityLabel: 'Extra activity',
	extraActivityPlaceholder: 'Select extra activity',
	durationLabel: 'Extra activity duration',
	cancelButton: 'Cancel',
	addButton: 'Add',
	saveButton: 'Save',
	extraActivityRequiredError: 'Extra activity is required',
	activityOnlyAtLastStationError:
		'This activity can only be added at the last station of the assignment',
	activityOnlyAtFirstStationError:
		'This activity can only be added at the first station of the assignment',
};
